const Descarga = () =>
{
    return (
        <div
            style={
            {
                background: '#eef3f7',
                borderRadius: '8px',
                padding: '16px',
                textAlign: 'center'
            }}
        >
            <div
                style={
                {
                    marginBottom: '12px',
                    textAlign: 'left',
                    fontSize: '13px'
                }}
            >
                <label
                    style={
                    {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        cursor: 'pointer'
                    }}
                >
                    <input type="checkbox" />
                    {'Descarga consolidada (1 archivo por selección)'}
                </label>
            </div>
            <strong
                style={
                {
                    fontSize: '22px',
                    display: 'block',
                    marginBottom: '4px'
                }}
            >
                {'1 archivo XLSX'}
            </strong>
            <span>{'Combinatoria real: Región × Año'}</span>
            <div
                style={
                {
                    marginTop: '12px',
                    fontSize: '12px',
                    color: '#555',
                    maxHeight: '120px',
                    overflow: 'auto',
                    textAlign: 'left'
                }}
            >
                {'• IFOP_Dataset_1965_Todas.xlsx'}
            </div>
            <button
                style={
                {
                    marginTop: '12px',
                    padding: '10px 18px',
                    border: 'none',
                    borderRadius: '6px',
                    backgroundColor: '#4A6F8A',
                    color: '#FFF',
                    fontSize: ' 14px',
                    cursor: 'pointer'
                }}
            >
                {'Descargar datasets seleccionados'}
            </button>
        </div>
    );
}

export default Descarga;
